import React from "react";
import ReactDOM from "react-dom/client";
import MainPage from "./pages/MainPage";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from "./pages/About";
import MainLayout from "./pages/MainLayout";
import Services from "./pages/Services";
import Portofolio from "./pages/Portofolio";
import Contact from "./pages/Contact";
const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "/", element: <MainPage /> },
      { path: "about", element: <About /> },
      { path: "services", element: <Services /> },
      { path: "portfolio", element: <Portofolio /> },
      { path: "contact", element: <Contact /> },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
